export default __webpack_public_path__ + "e0d605352ebc33a628976adf1cf3f28a.svg";